export default __webpack_public_path__ + "static/chime-ddde6c6c1fea55a835ec6c6c3972274c.mp3";